import { useCallback } from 'react';

import EditAdditionalIncome from '../../../../common/Steps/EditAdditionalIncome';

const Controller = (props: any) => {
  const { presModel, send, context: workflowDetails } = props;
  const { updatedUser = {}, editIncome } = workflowDetails || {};

  const {
    incomes: { additional },
  } = updatedUser;

  const onSubmit = useCallback(
    (updatedIncome: any) => {
      send('Next', {
        updatedUser: {
          ...updatedUser,
          incomes: {
            ...updatedUser.incomes,
            additional: additional.map((v: any, i: number) =>
              i !== editIncome ? v : { ...v, ...updatedIncome },
            ),
          },
        },
      });
    },
    [updatedUser, send, additional, editIncome],
  );

  const onBack = useCallback(() => {
    send('Previous');
  }, [send]);

  const onRemove = useCallback(() => {
    send('Next', {
      updatedUser: {
        ...updatedUser,
        incomes: {
          ...updatedUser.incomes,
          additional: additional.filter(
            (v: any, i: number) => i !== editIncome,
          ),
        },
      },
    });
  }, [editIncome, additional, updatedUser, send]);

  return (
    <EditAdditionalIncome
      editedIncome={additional[editIncome]}
      presModel={presModel}
      onBack={onBack}
      onRemove={onRemove}
      onSubmit={onSubmit}
    />
  );
};

Controller.displayName = 'ApplicantIncomeAdditionalEdit.Controller';
export default Controller;
